<mat-card>
  <mat-card-header style="background-color: #684637;">
    <div class="flex justify-between" style="width: 100%;">
      <div class="fontTitleModal"> เพิ่มรายงานการตรวจปล่อยสินค้า </div>
      <div>
        <button mat-icon-button class="close-button" (click)="endPopup('close')">
          <i class="ti ti-x text-white"></i>
        </button>
      </div>
    </div>
  </mat-card-header>
  <mat-dialog-content>
    <div class="pl-22 pr-22 flex flex-col gap-4">
      <div class="flex-row flex justify-between gap-2.5" style="align-items: center;">
        <div class="mat-popup-header flex flex-col">
          <h4>เลขที่การแจ้งตรวจปล่อยสินค้า <span style="color:red;">*</span></h4>
        </div>
        <div class="mat-popup flex flex-row justify-between items-center" style="width:74%">
          <div>:</div>
          <mat-form-field style="flex: 0 95%;" class="flex">
            <input type="text" matInput [formControl]="inspectPetitionNumberSearch"
              placeholder="เลขที่การแจ้งตรวจปล่อยสินค้า" [matAutocomplete]="autoax2" [readonly]="selectedItem">
            <mat-autocomplete #autoax2="matAutocomplete" [displayWith]="displayInspectionNumber"
              (optionSelected)="selectionInspectionNumber($event)">
              <mat-option *ngFor="let option of filteredOptionsInspectPetitionNumber$ | async" [value]="option">
                {{option.inspectionNumber}}
              </mat-option>
            </mat-autocomplete>
            <button mat-icon-button matTooltip="ลบ" (click)="cancelItem()"
              style="width: 48px !important; margin-right: -10px" *ngIf="selectedItem">
              <i class="ti ti-backspace" style="color: #8e9db1;"></i>
            </button>
          </mat-form-field>
        </div>
      </div>

      <ng-container *ngIf="!selectedItem">
        <div class="flex-row flex justify-between gap-2.5" style="align-items: center;">
          <div class="mat-popup-header flex flex-col">
            <h4></h4>
          </div>
          <div class="mat-popup flex flex-row justify-between items-center" style="width:74%">
            <div></div>
            <div style="flex: 0 95%;" class="flex">
              <p style="color: red;">หากไม่พบเลขที่แจ้งงานตรวจปล่อยสินค้า กรุณาติดต่อสำนักงานมาตราฐานสินค้า โทร 0 2547
                4748</p>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedItem">
        <div class="flex-row flex justify-between gap-2.5" style="align-items: center;">
          <div class="mat-popup-header flex flex-col">
            <h4>วันและเวลาที่ได้รับคำร้อง</h4>
          </div>
          <div class="mat-popup flex flex-row justify-between items-center" style="width:74%">
            <div>:</div>
            <div style="flex: 0 95%;" class="flex">
              <p>{{selectedData.inspectionDate | thaidate}} เวลา {{selectedData.inspectionDate | date:'HH:mm'}} น.</p>
            </div>
          </div>
        </div>

        <div class="flex-row flex justify-between gap-2.5" style="align-items: center;">
          <div class="mat-popup-header flex flex-col">
            <h4>ชื่อสถานที่ตรวจสอบ</h4>
          </div>
          <div class="mat-popup flex flex-row justify-between items-center" style="width:74%">
            <div>:</div>
            <mat-form-field style="flex: 0 95%;" class="flex">
              <input autocomplete="off" matInput placeholder="" [(ngModel)]="selectedData.inspectionPlace"
                name="inspectionPlace" readonly />
            </mat-form-field>
          </div>
        </div>

        <div class="flex-row flex justify-between gap-2.5" style="align-items: center;">
          <div class="mat-popup-header flex flex-col">
            <h4>ที่ตั้ง</h4>
          </div>
          <div class="mat-popup flex flex-row justify-between items-center" style="width:74%">
            <div>:</div>
            <mat-form-field style="flex: 0 95%;" class="flex">
              <input autocomplete="off" matInput placeholder="" [(ngModel)]="selectedData.inspectionAddress"
                name="inspectionAddress" readonly />
            </mat-form-field>
          </div>
        </div>

        <div class="flex-row flex justify-between gap-2.5" style="align-items: center;">
          <div class="mat-popup-header flex flex-col">
            <h4>แขวง / ตำบล</h4>
          </div>
          <div class="mat-popup flex flex-row justify-between items-center" style="width:74%">
            <div>:</div>
            <mat-form-field style="flex: 0 95%;" class="flex">
              <input autocomplete="off" matInput placeholder="" [(ngModel)]="selectedData.inspectionSubdistrict"
                name="inspectionSubdistrict" readonly />
            </mat-form-field>
          </div>
        </div>


        <div class="flex-row flex justify-between gap-2.5" style="align-items: center;">
          <div class="mat-popup-header flex flex-col">
            <h4>เขต / อำเภอ</h4>
          </div>
          <div class="mat-popup flex flex-row justify-between items-center" style="width:74%">
            <div>:</div>
            <mat-form-field style="flex: 0 95%;" class="flex">
              <input autocomplete="off" matInput placeholder="" [(ngModel)]="selectedData.inspectionDistrict"
                name="inspectionDistrict" readonly />
            </mat-form-field>
          </div>
        </div>


        <div class="flex-row flex justify-between gap-2.5" style="align-items: center;">
          <div class="mat-popup-header flex flex-col">
            <h4>จังหวัด</h4>
          </div>
          <div class="mat-popup flex flex-row justify-between items-center" style="width:74%">
            <div>:</div>
            <mat-form-field style="flex: 0 95%;" class="flex">
              <input autocomplete="off" matInput placeholder="" [(ngModel)]="selectedData.inspectionProvince"
                name="inspectionProvince" readonly />
            </mat-form-field>
          </div>
        </div>


        <div class="flex-row flex justify-between gap-2.5" style="align-items: center;">
          <div class="mat-popup-header flex flex-col">
            <h4>รหัสไปรษณีย์</h4>
          </div>
          <div class="mat-popup flex flex-row justify-between items-center" style="width:74%">
            <div>:</div>
            <mat-form-field style="flex: 0 95%;" class="flex">
              <input autocomplete="off" matInput placeholder="" [(ngModel)]="selectedData.inspectionPostCode"
                name="inspectionPostCode" readonly />
            </mat-form-field>
          </div>
        </div>

      </ng-container>

      <div class="flex-row flex justify-center gap-2.5" style="gap: 10px;" *ngIf="selectedItem">
        <button mat-raised-button color="accent" (click)="endPopup('save')">บันทึก</button>
        <button mat-raised-button (click)="endPopup('close')">ยกเลิก</button>
      </div>
    </div>
  </mat-dialog-content>